import { Component, Input, Output, EventEmitter} from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { countries_data } from '../../../../constants/countries';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { InputGroupModule } from 'primeng/inputgroup';
import { SelectModule } from 'primeng/select';

@Component({
  selector: 'app-custom-phone-number',
  templateUrl: './custom-phone-number.component.html',
  imports : [
    SelectModule, 
    CommonModule,
    FormsModule,
    InputGroupModule,
    InputTextModule,
    ReactiveFormsModule,
    SelectModule
  ]
})
export class CustomPhoneNumberComponent {
  countries = countries_data
  @Input() customPhoneForm!: FormGroup;
  @Input() isCustomer!: boolean;
  @Input() requiredErrorMessage!: string;
  @Input() customPlaceholder!: string;
  @Output() countryChange = new EventEmitter<any>();


   ngOnInit() {
    // Set default country as India (+91)
    this.customPhoneForm.get('country')?.setValue(
      this.countries.find((country) => country.dial_code === '+91')
    );

    this.customPhoneForm.get('phoneNumber')?.addValidators([
      Validators.required,
      Validators.pattern(/^\d{10}$/), 
    ]);
  }

  onCountryChange(event: any) {
    this.countryChange.emit(event);
  }

  validateNumber(event: KeyboardEvent) {
    const inputChar = event.key
    if (!/^\d+$/.test(inputChar)) {
      event.preventDefault();
    }
  }
}
